<template>
  <div class="password-box">
    <div class="title" v-if="role == 2">重置密码</div>
    <div class="hide" style="display:none;">
      <input type="input" />
      <input type="password" />
    </div>
    <div class="input">
      <el-input
        class="btn-form"
        maxlength="11"
        placeholder="请输入手机号"
        v-model="loginForm.mobile"
        clearable
      ></el-input>
    </div>
    <div class="input yanzm">
      <el-input
        class="btn-form"
        maxlength="6"
        placeholder="短信验证码"
        v-model="loginForm.smsCode"
      ></el-input
      ><el-button
        @click="sendYanzm"
        :disabled="yanzmDisabled"
        class="sendYanzm"
        type="text"
        >{{ yanzmStr }}</el-button
      >
    </div>
    <div class="input">
      <el-input
        class="btn-form"
        maxlength="20"
        placeholder="密码至少6位，且由大小写字母、数字组成"
        v-model="loginForm.pwd"
        show-password
        clearable
      ></el-input>
    </div>
    <div class="input">
      <el-input
        class="btn-form"
        maxlength="20"
        @keyup.enter.native="loginHandler"
        placeholder="请重复输入密码"
        v-model="loginForm.repeatPwd"
        show-password
        clearable
      ></el-input>
    </div>
    <div class="btns">
      <el-button type="primary" @click="loginHandler()">重置密码</el-button>
    </div>
    <div class="user-reg">
      我已想起密码，<a class="btn-txt" @click="goBackLogin()">直接登录</a>
    </div>
  </div>
</template>

<script>
import { LOGIN_API,REPORT_API } from "@/api.js";
import { isMobile,isPwd } from '@/untils/validate'
export default {
  props: ['role'],
  data() {
    return {
      loginForm: {
        mobile: '',
        pwd: '',
        repeatPwd: '',
        smsCode: '',
        randomStr: '',
        ticket: '',
      },
      confirm: {},
      yanzmDisabled: false,
      yanzmTime: 60,
      yanzmStr: '发送验证码',
    }
  },
  mounted() {},
  methods: {
    goBackLogin() {
      this.$emit('goBackLogin')
    },
    sendMsmHandler() {
      if (!this.loginForm.mobile) {
        this.$message.error('请输入手机号！')
        return
      }
      let post = {
        type: 3,
        ...this.loginForm,
      }
      let url = `${REPORT_API}/api/account/smscode`
      if (this.role == 1) {
        url = `${LOGIN_API}/customer/api/smscode`
      }
      this.$axios.post(url, post).then((res) => {
        if (this.role == 1) {
          if (res.data.errno == 0) {
            this.setTimer()
          } else {
            this.$message.error(res.data.errmsg)
          }
        } else {
          if (res.data.code == 0) {
            this.setTimer()
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    setTimer() {
      this.$message.success('短信验证码发送成功！')
      this.yanzmDisabled = true
      this.yanzmTime = 60
      window.loginTimer ? window.clearInterval(window.loginTimer) : null
      window.loginTimer = window.setInterval(() => {
        this.yanzmTime--
        if (this.yanzmTime < 0) {
          this.yanzmDisabled = false
          window.clearInterval(window.loginTimer)
          this.yanzmStr = '发送验证码'
          return
        }
        this.yanzmStr = '验证码（' + this.yanzmTime + '秒）'
      }, 1000)
    },
    callback(res) {
      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      if (res && res.ret === 0) {
        this.loginForm.randomStr = res.randstr
        this.loginForm.ticket = res.ticket
        this.sendMsmHandler()
      }
    },
    sendYanzm() {
      if (!isMobile(this.loginForm.mobile)) {
        this.$message.error('亲，手机号格式不正确，请重试！')
        return
      }
      var captcha1 = new TencentCaptcha('2012913766', this.callback)
      captcha1.show()
    },
    loginHandler() {
      if (!this.loginForm.mobile || !this.loginForm.pwd) {
        this.$message.error('请输入手机号、密码！')
        return
      }
      if (!this.loginForm.smsCode) {
        this.$message.error('请输入短信验证码！')
        return
      }
      if (this.loginForm.pwd != this.loginForm.repeatPwd) {
        this.$message.error('亲，您输入的密码不一致，请重试！')
        return
      }
      if (!isPwd(this.loginForm.pwd)) {
        this.$message.error(
          '亲，您的密码不符合要求：密码至少6位，包含大小写字母、数字！'
        )
        return
      }
      let post = this.loginForm
      let url = `${LOGIN_API}/customer/api/retrievePassword`
      if (this.role == 2) {
        url =  `${REPORT_API}/api/account/retrievePassword`
      }
      this.$axios.post(url, post).then((res) => {
        if (this.role == 1) {
          if (res.data.errno == 0) {
            this.$message.success('重置密码成功！')
            this.goBackLogin()
          } else {
            this.$message.error(res.data.errmsg)
          }
        } else {
          if (res.data.code == 0) {
            this.$message.success('重置密码成功！')
            this.goBackLogin()
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.password-box {
  width: 315px;
  margin: 0px auto 0px;
  .title {
    font-size: 20px;
    font-weight: 300;
    text-align: center;
    padding: 0px 0px 15px;
  }
  .input {
    padding: 10px 0px;
  }
  .yanzm {
    position: relative;
    .sendYanzm {
      position: absolute;
      top: 10px;
      right: 15px;
      color: #29bdb9;
      &.is-disabled {
        color: #999;
      }
    }
  }
  .viewDetail {
    font-size: 11px;
    padding: 15px 0px;
    a {
      color: #29bdb9;
      cursor: pointer;
    }
  }
  .user-reg {
    padding: 10px 0px;
    text-align: center;
    font-size: 14px;
    a {
      font-size: 14px;
      cursor: pointer;
      color: #29bdb9;
    }
  }
}
.dialogHtml {
  max-height: 500px;
  overflow: auto;
  overflow: auto;
  margin: 0px;
  white-space: pre-wrap;
}
</style>

<style>
.el-checkbox__inner {
  border-color: #29bdb9 !important;
  color: #29bdb9 !important;
}
.el-checkbox__label {
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #29bdb9 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/account/model/reset-password.vue